export const LOGO_SIZES = {
  width: 73,
  height: 48,
} as const;

import { MenuItem } from '@/features/navigation/model/types';
// 사전방문예약 hidden
// {
//   id: 3,
//     translationKey: 'menu.reservation',
//   href: '/reservation/apply#top',
//   submenu: [
//   {
//     id: 301,
//     translationKey: 'menu.reservation_sub.apply',
//     href: '/reservation/apply#reservation-title',
//   },
//   {
//     id: 302,
//     translationKey: 'menu.reservation_sub.check',
//     href: '/reservation/check#reservation-title',
//   },
// ],
// },

export const MENU_ITEMS: MenuItem[] = [
  {
    id: 1,
    translationKey: 'menu.visa_center',
    href: '/visa-center/intro#top',
    submenu: [
      {
        id: 101,
        translationKey: 'menu.visa_center_sub.intro',
        href: '/visa-center/intro#visa-center-h1',
      },
      {
        id: 102,
        translationKey: 'menu.visa_center_sub.time_location',
        href: '/visa-center/location#visa-center-h1',
      },
      {
        id: 103,
        translationKey: 'menu.visa_center_sub.fee_service',
        href: '/visa-center/fee#visa-center-h1',
      },
      {
        id: 104,
        translationKey: 'menu.visa_center_sub.consulate_info',
        href: 'https://overseas.mofa.go.kr/cn-qingdao-ko/brd/m_1380/list.do',
        target: '_blank',
      },
    ],
  },
  {
    id: 2,
    translationKey: 'menu.visa_application',
    href: '/visa-guide#top',
    submenu: [
      {
        id: 201,
        translationKey: 'menu.visa_application_sub.guide',
        href: '/visa-guide#visa-guide-h1',
      },
    ],
  },
  {
    id: 4,
    translationKey: 'menu.visa_check',
    href: 'https://www.visa.go.kr/openPage.do?MENU_ID=10301',
    rel: 'noopener noreferrer',
    target: '_blank',
    submenu: [
      {
        id: 401,
        translationKey: 'menu.visa_check_sub.status',
        href: 'https://www.visa.go.kr/openPage.do?MENU_ID=10301',
        rel: 'noopener noreferrer',
        target: '_blank',
      },
    ],
  },
  {
    id: 5,
    translationKey: 'menu.customer',
    href: '/customer/notice#top',
    submenu: [
      {
        id: 501,
        translationKey: 'menu.customer_sub.notice',
        href: '/customer/notice#customer-title',
      },
      {
        id: 502,
        translationKey: 'menu.customer_sub.faq',
        href: '/customer/faq#customer-title',
      },
      {
        id: 503,
        translationKey: 'menu.customer_sub.qna',
        href: '/customer/qna#customer-title',
      },
    ],
  },
  {
    id: 6,
    translationKey: 'menu.travel',
    href: '/travel/spots#top',
    submenu: [
      {
        id: 601,
        translationKey: 'tour_information_menu.spots',
        href: '/travel/spots#travel-title',
      },
      {
        id: 602,
        translationKey: 'tour_information_menu.culture',
        href: '/travel/culture#travel-title',
      },
      {
        id: 603,
        translationKey: 'tour_information_menu.festival',
        href: '/travel/festival#travel-title',
      },
      {
        id: 604,
        translationKey: 'tour_information_menu.course',
        href: '/travel/course#travel-title',
      },
      {
        id: 605,
        translationKey: 'tour_information_menu.sports',
        href: '/travel/sports#travel-title',
      },
      {
        id: 606,
        translationKey: 'tour_information_menu.accommodation',
        href: '/travel/accommodation#travel-title',
      },
      {
        id: 607,
        translationKey: 'tour_information_menu.shopping',
        href: '/travel/shopping#travel-title',
      },
      {
        id: 608,
        translationKey: 'tour_information_menu.restaurant',
        href: '/travel/restaurant#travel-title',
      },
    ],
  },
];
